import { Card, TextField, Box, Typography, Tooltip, IconButton, lighten, useTheme } from '@mui/material';
import { palette } from '../theme/palette';
import { useState, useEffect } from 'react';
import { ReactComponent as MapMakerIcon } from '../assets/icons/main/map-marker-icon.svg';
import { ReactComponent as DeleteIcon } from '../assets/icons/main/delete-icon.svg';
import AddButtonWithAccessCheck from './AddButtonWithAccessCheck';
import EditButtonWithAccessCheck from './EditButtonWithAccessCheck';
import chroma from 'chroma-js';
import { get } from 'lodash';
import { useOutletContext } from 'react-router-dom';



const CardWithLabel = (props: any) => {
  const themeData:any = useTheme();    
  const [cardPalette, setCardPalette] = useState<any[]>([]);
  const Styles = {
    card: {
      maxHeight: '190px',
      padding: '32px',
      borderRadius: '18px',
      border: '0px 0px 4px 0px',
      marginTop: '16px',
    },
    circleIcon: {
      width: '42px',
      height: '42px',
      padding: '8px 9px 8px 8px',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: palette.primary.contrastText,
    },
    number: {
      fontFamily: 'Open Sans',
      fontSize: '1.3rem',
      fontWeight: 800,
      lineHeight: '27px',
      letterSpacing: '0em',
      textAlign: 'center',
    },
    icon: {
      padding: 0,
    },
    content: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gridGap: '8px',
    },

    locationIcon: {
      display: 'flex',
      width: '32px',
      height: '32px',
      padding: '10px 0px 1.33px 15px',
    },

    title: {
      display: 'flex',
      border: '0px 0px 1px 0px',
      fontStyle: 'italic',
    },
  };


  useEffect(() => {
    const colors = chroma.scale([themeData.palette.primary.main, chroma(themeData.palette.primary.main).set('hsl.h', '+180')])
      .mode('lch')
      .colors(6)
      .map((color: any, index: any) => ({
        primaryColor: color,
        })) ;
    setCardPalette(colors);
  }, [themeData.palette.primary.main]);
  return (
    <div>
      <Card
        sx={{
          ...Styles.card,
          borderBottom: `4px solid ${get(cardPalette, `${[props.colorval % 6]}.primaryColor`, '')}`,
        }}
      >
        {props.addCard && <AddButtonWithAccessCheck from='CardWithLabel' onClick={props.onAddCard} />}
        {!props.addCard && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: '42px',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  ...Styles.circleIcon,
                  backgroundColor: `${get(cardPalette, `${[props.colorval % 6]}.primaryColor`, '')}`,
                }}
              >
                <Typography sx={Styles.number} variant='body1'>
                  {props.number > 9 ? props.number : '0' + props.number}
                </Typography>
              </div>
              {
                !props.isSaved ? (
                  props.levelData.length &&
                  props.levelData.length > 1 && (
                    <Tooltip
                      title={
                        <Typography variant='subtitle1' style={{ fontSize: '1rem' }}>
                          Delete Level
                        </Typography>
                      }
                      placement='left'
                      arrow
                    >
                      <IconButton
                        onClick={() => {
                          props.onDeleteCard(props.number);
                          props.setAjvErrors({});
                        }}
                        style={Styles.icon}
                      >
                        <DeleteIcon style={{color:themeData.palette.custom.light}} />
                      </IconButton>
                    </Tooltip>
                  )
                ) : (
                  <EditButtonWithAccessCheck
                    onClick={() => {
                      props.onEditClick(props.number);
                      props.setAjvErrors({});
                    }}
                    otherProps={{ levelName: 'Level', toolTipPlacement: 'left' }}
                  />
                )
                
              }
            </div>

            <Box sx={Styles.content}>
              <MapMakerIcon
                style={{
                  ...Styles.locationIcon,
                  stroke: `${get(cardPalette, `${[props.colorval % 6]}.primaryColor`, '')}`,
                  fill: `${get(cardPalette, `${[props.colorval % 6]}.primaryColor`, '')}`,
                }}
              />

              {props.isSaved ? (
                props.editable ? (
                  <TextField
                    required
                    fullWidth
                    placeholder='Enter Ontology Level'
                    variant='standard'
                    size='small'
                    name='level_name'
                    value={props.inputValue.level_name}
                    sx={{
                      '.MuiFormHelperText-root': {
                        color: 'rgba(255,0,0,0.5) !important',
                        marginTop: '2px !important',
                        marginLeft: '5px !important',
                        fontSize: '0.7rem !important',
                        lineHeight: '1 !important',
                        marginBottom: '-12px',
                      },
                      '& .MuiInput-input': {
                        padding: '10px 16px',
                        gap: '10px',
                        fontSize: '1rem',
                        fontWeight: '400',
                        '&::placeholder': {
                          fontSize: '1rem',
                          fontStyle: 'italic',
                          fontWeight: '400',
                          lineHeight: 'normal',
                          color: lighten(themeData.palette.text.primary, 0.3),
                          },
                      },
                      '& .MuiInput-root:before': {
                        borderBottom: `1px solid ${themeData.palette.customBorderColor.main} !important`,
                        '&:hover': {
                          borderBottom: `1px solid ${themeData.palette.customBorderColor.main} !important`,
                        },
                      },
                      '& .MuiInput-root:after': {
                        borderBottom: `1px solid ${themeData.palette.text.primary}`,
                      },
                    }}
                    onChange={(event: any) => props.onInputChange(event, props.inputValue.level_number)}
                    error={props.isError}
                    helperText={props.errorMsg}
                  />
                ) : props.inputValue.level_name.length > 35 ? (
                  <Tooltip
                    title={
                      <Typography variant='subtitle1' style={{ fontSize: '1rem' }}>
                        {props.inputValue.level_name}
                      </Typography>
                    }
                    placement='left'
                    arrow
                  >
                    <Typography
                      variant='h1'
                      sx={{
                        fontSize: '1.5rem',
                        fontStyle: 'normal',
                        fontWeight: '800',
                        lineHeight: 'normal',
                        textTransform: 'uppercase',
                        padding: '0px',
                        margin: '0px',
                        marginTop: '5px',
                        display: ' inline-block',
                        width: '250px',
                        whiteSpace: 'nowrap',
                        overflow: ' hidden !important',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {props.inputValue.level_name}
                    </Typography>
                  </Tooltip>
                ) : (
                  <Typography
                    variant='h1'
                    sx={{
                      color: ` ${get(cardPalette, `${[props.colorval % 6]}.primaryColor`, '')}`,
                      fontSize: '1.5rem',
                      fontStyle: 'normal',
                      fontWeight: '800',
                      lineHeight: 'normal',
                      textTransform: 'uppercase',
                      padding: '0px',
                      margin: '0px',
                      marginTop: '5px',
                      display: ' inline-block',
                      width: '250px',
                      whiteSpace: 'nowrap',
                      overflow: ' hidden !important',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {props.inputValue.level_name}
                  </Typography>
                )
              ) : (
                <TextField
                  required
                  fullWidth
                  placeholder='Enter Ontology Level'
                  variant='standard'
                  color='secondary'
                  size='small'
                  name='level_name'
                  value={props.inputValue.level_name}
                  sx={{
                    '.MuiFormHelperText-root': {
                      color: themeData.palette.primary.contrastText ,//'rgba(255,0,0,0.5) !important',
                      marginTop: '2px !important',
                      marginLeft: '5px !important',
                      fontSize: '0.7rem !important',
                      lineHeight: '1 !important',
                      marginBottom: '-12px',
                    },
                    '& .MuiInput-input': {
                      padding: '13px 16px',
                      gap: '10px',
                      fontSize: '1rem',
                      //color:  themeData.palette.primary.contrastText ,//'#64759F',
                      fontWeight: '400',
                      '&::placeholder': {
                        fontSize: '1rem',
                        fontStyle: 'italic',
                        fontWeight: '400',
                        lineHeight: 'normal',
                        // color: lighten(themeData.palette.text.primary,0.3) //'#7382A9',
                      },
                    },
                    '& .MuiInput-root:before': {
                      borderBottom: `1px solid ${themeData.palette.customBorderColor.main}`,
                    },
                    '& .MuiInput-root:after': {
                      borderBottom: `1px solid ${themeData.palette.text.primary}`,
                    },
                  }}
                  onChange={(event: any) => props.onInputChange(event, props.inputValue.level_number)}
                  error={props.isError}
                  helperText={props.errorMsg}
                />
              )}
            </Box>
          </div>
        )}
      </Card>
    </div>
  );
};

export default CardWithLabel;
